import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
  name: 'safeTranslate',
  standalone: true,
  pure: true
})
export class SafeTranslatePipe implements PipeTransform {
  transloco = inject(TranslocoService);

  transform(value: any): string {
    if (!value || typeof value !== 'string') return value;

    const looksLikeKey = value.includes('.');

    if (!looksLikeKey) {
      return value;
    }
    
    const translated = this.transloco.translate(value);
    
    if (!translated || translated === value) {
      return value;
    }

    return translated;
  }
}